var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "sub-values" }, [
        _c(
          "div",
          {
            staticClass: "sub-value clickable",
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [
            _c("div", { staticClass: "label" }, [_vm._v("Gehaltsbandbreite")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(_vm.data.salary.salary) +
                  " - " +
                  _vm._s(_vm.data.salary.salaryMax) +
                  " €"
              )
            ])
          ]
        ),
        _vm._v(" "),
        _vm.withCollective &&
        _vm.data.salaryCollective &&
        _vm.data.salaryCollective.collective !== "none"
          ? _c(
              "div",
              {
                staticClass: "sub-value clickable",
                on: {
                  click: function($event) {
                    return _vm.$emit("click")
                  }
                }
              },
              [
                _c("div", { staticClass: "label" }, [_vm._v("Mindestgehalt")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.data.salaryCollective.collective === "unknown"
                      ? [_vm._v("Unbekannt")]
                      : [
                          _vm._v(
                            _vm._s(_vm.data.salaryCollective.salary) + " €"
                          )
                        ]
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }